import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission, requireModule } from '../../../app/guards'

/**
 * Projects: the portfolio and each workspace need projects.read; the material issues and cost entries
 * registers are also open to those who record them or read project money without it.
 */
export const Route = createFileRoute('/_app/projects')({
  staticData: { crumb: 'projects' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'projects')
    requireAnyPermission(
      context.session,
      'projects.read',
      'projects.materials',
      'projects.cost_entries',
      'projects.financials',
      // Guarantees open with projects.contract as well.
      'projects.contract',
      // P6: people's hourly cost is its own page (projects.rates only).
      'projects.rates',
      // P6: My time and Time approvals.
      'projects.time',
      'projects.time_approve',
    )
  },
  component: Outlet,
})
